import { render } from "./PredictionTab.vue?vue&type=template&id=53ab96d7"
import script from "./PredictionTab.vue?vue&type=script&lang=js"
export * from "./PredictionTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/adelaplace/PycharmProjects/smartcast/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__